import * as React from 'react'

import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

const SettingsManageBankAccountsViewChunk = React.lazy(() =>
  import('../containers/SettingsManageBankAccountsView').then(
    ({ SettingsManageBankAccountsView }) => ({
      default: SettingsManageBankAccountsView,
    })
  )
)

export const SettingsManageBankAccountsPage = () => {
  const intl = useProcurifyIntl()

  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.manageBankAccountsPageTitle)}
      breadcrumbs={[
        {
          link: url('SettingsPage'),
          name: intl.formatMessage(messages.settingsPageTitle),
        },
        {
          name: intl.formatMessage(messages.manageBankAccountsPageTitle),
        },
      ]}
    >
      <SettingsManageBankAccountsViewChunk />
    </Page>
  )
}
